import RandomView from "../componentView/RandomView";
import { ListRendererFn } from "./ListRenderer";
import React from "react";
const RandomRenderer: ListRendererFn = ({ onFocus, leaveFor, list }) => {
  return (
    <RandomView list={list} key={list.uuid} leaveFor={leaveFor} onFocus={onFocus} />
  );
};
export default RandomRenderer;
